module.exports = __webpack_public_path__ + "static/img/tab333.04aa79b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabimg/tab333.png
// module id = H9wQ
// module chunks = 0